// extracted by mini-css-extract-plugin
export default {"container":"Legal_container__z1vif","content":"Legal_content__fh0RU","lastUpdated":"Legal_lastUpdated__cAweM","section":"Legal_section__KjPrv"};